function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRoundClean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.5 93.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.71,33.5c19.62.3,37.07,2.75,50.95,8.77,0,.21-.24.33-.37.43-1.06.82-2.43,1.71-3.53,2.55-13-5.4-29-7.79-47.13-8V33.69C30.63,33.62,30.62,33.52,30.71,33.5Z",
    transform: "translate(-5.28 -5.2)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.29,52.69A42.51352,42.51352,0,0,1,79,55c-8.92-5.68-20.57-8.6-34-9.74A30.57059,30.57059,0,0,1,46.51,42s0-.25.13-.12a127.93066,127.93066,0,0,1,20,3.76C72.8,47.34,78.52,49.49,83.29,52.69Z",
    transform: "translate(-5.28 -5.2)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.82,47.46c13.14.45,25.27,1.91,35.3,5.47.07.16-.15.3-.24.38-.87.68-2.07,1.36-3,2.07C54,51.89,42.41,51.1,30.62,50.51c0-1,.1-1.89.13-2.85C30.75,47.54,30.75,47.46,30.82,47.46Z",
    transform: "translate(-5.28 -5.2)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.47,53.78C46,54.49,50.66,55.3,55,56.33s8.46,2.15,11.75,4.26c-1.12.69-2.38,1.23-3.53,1.87-6.52-3.14-14.4-4.92-23.07-5.9A21.55064,21.55064,0,0,1,41.47,53.78Z",
    transform: "translate(-5.28 -5.2)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4,61.87A16.09064,16.09064,0,0,1,51,63.94a30.27,30.27,0,0,0-9.37-2.19c-3.46-.41-7.17-.59-10.84-.75a15.29952,15.29952,0,0,1,.06-2.37C39.06,59,47,59.67,53.4,61.87Z",
    transform: "translate(-5.28 -5.2)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.49,67.53a28.84341,28.84341,0,0,0-2.74,1.28c-3.88-1.71-8.86-2.3-13.7-3a13.4191,13.4191,0,0,1,1.1-2.13c5,.6,9.87,1.34,13.81,3A3.71,3.71,0,0,1,52.49,67.53Z",
    transform: "translate(-5.28 -5.2)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,69.11A12.7699,12.7699,0,0,1,41,71a39.83987,39.83987,0,0,0-10.41-1.4V67.7A43.64014,43.64014,0,0,1,43,69.11Z",
    transform: "translate(-5.28 -5.2)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5,73.07a24.23932,24.23932,0,0,1-2.2,1.4,26.74034,26.74034,0,0,0-5.72-1.22,12.6497,12.6497,0,0,1,.86-1.58A15.94,15.94,0,0,1,40.5,73.07Z",
    transform: "translate(-5.28 -5.2)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.07,87.28a35.1,35.1,0,0,1,0-70.1V12.64a39.65,39.65,0,0,0,0,79.19Z",
    transform: "translate(-5.28 -5.2)",
    style: {
      fill: "#ffd213"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.86,12.64v4.54a35.1,35.1,0,0,1,0,70.1v4.55a39.65,39.65,0,0,0,0-79.19Z",
    transform: "translate(-5.28 -5.2)",
    style: {
      fill: "#ffd213"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRoundClean);
export default __webpack_public_path__ + "static/media/logo-round-clean.8e6e2654b02545aad1dd63a06da0d140.svg";
export { ForwardRef as ReactComponent };